var map = {
	"./payex-logo-h.svg": 9740,
	"./payex-logo-neg.png": 128,
	"./payex-logo-neg.svg": 7552,
	"./payex-logo-v.svg": 7492,
	"./payex-logo.png": 8812,
	"./payex-logo.svg": 4592
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 7596;